import _ from 'lodash';

export const getTabFromPath = <T>(pathname: string, tabs: T[], defaultTab: T) => {
    const splitUrl = pathname.split('/');
    const tab = splitUrl.find((path) => tabs.includes(_.capitalize(path) as T));

    return tab ? (_.capitalize(tab) as T) : defaultTab;
};
